const templateUrl = require('./no-shipments-upsell.html');

const app = angular.module('msi.upsell.ogNoShipmentsUpsell', []);

app.component('ogNoShipmentsUpsell', {
  templateUrl: templateUrl,
  controller: ['config', function(merchSettings) {
    this.landingPage = merchSettings.landingPageUrl;
  }]
});

module.exports = app.name;
